import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import TeamsCard from "../../utils/teams_card";
import plusImage from "../../assets/plus.png";

export default function DashTournaments() {
  const { user } = useSelector((state) => state.user);
  const [tournaments, settournaments] = useState([]);
  const [displayedtournaments, setDisplayedtournaments] = useState(10);

  const handleShowMore = () => {
    setDisplayedtournaments((prevDisplayed) => prevDisplayed + 1);
  };

  useEffect(() => {
    const fetchtournaments = async () => {
      try {
        const response = await fetch(
          `https://server-postgre.vercel.app/get-user-tournaments`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ user_id: user.id }),
          }
        );
        const data = await response.json();
        settournaments(data);
      } catch (error) {
        console.error("Error fetching tournaments:", error);
      }
    };

    fetchtournaments();
  }, [user.id]);

  return (
    <div className="flex " style={{ maxHeight: "245px" }}>
      {tournaments.slice(0, displayedtournaments).map((tournament) => (
        <a
          href={`/dashboard?tab=tournamentsDetails/${tournament.id}`}
          key={tournament.id}
          className="block mx-2 text-center bg-gradient-to-b from-white to-gray-200 rounded-lg p-8"
        >
          <TeamsCard
            image={`https://server-postgre.vercel.app/${tournament.photo_url}`}
            name={tournament.name}
          />
        </a>
      ))}
      <a
        href="/create-tournament"
        className="block mx-2 text-center bg-gradient-to-b from-white to-gray-200 rounded-lg p-8"
      >
        <TeamsCard image={plusImage} name="Crear Torneo" />
      </a>
      {tournaments.length > displayedtournaments && (
        <button
          onClick={handleShowMore}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-2"
        >
          Show 1 more
        </button>
      )}
    </div>
  );
}
